import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import UploadProgress from '../../../../../components/product/UploadProgress';

const propTypes = {
  total: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
  success: PropTypes.bool.isRequired,
  error: PropTypes.string.isRequired,
};

const UploadingStep = ({
  total,
  current,
  success,
  error,
  albumUploadReset,
}) => {
  return (
    <Fragment>
      <div className="mb-2">
        <h4 className="mb-0 text-primary text-center text-uppercase">
          Items uploading...
        </h4>
        <p className="mb-0 text-light text-center">
          Please keep your browser open!
        </p>
      </div>
      <UploadProgress
        total={total}
        current={current}
        success={success}
        error={error}
        visible={!!total}
        onDismiss={albumUploadReset}
        className="specialty-event-upload-progress"
      />
    </Fragment>
  );
};

UploadingStep.propTypes = propTypes;

export default UploadingStep;
